import "../../../css/Home.css";
import Accordion from "../../HelperComponents/HomeAccordion";

export default function P91Home() {

    console.log("This is the P91 homepage")
    return (
        <div className="home-container">
            <div className="home-text">
                <div className="home-accordion">
                    <Accordion />
                </div>
            </div>
        </div>

    );
}
